import { render, staticRenderFns } from "./MealSetRegister.vue?vue&type=template&id=08a569bc&scoped=true&"
import script from "./MealSetRegister.vue?vue&type=script&lang=js&"
export * from "./MealSetRegister.vue?vue&type=script&lang=js&"
import style0 from "./MealSetRegister.vue?vue&type=style&index=0&id=08a569bc&prod&lang=css&"
import style1 from "./MealSetRegister.vue?vue&type=style&index=1&id=08a569bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a569bc",
  null
  
)

export default component.exports